import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import Select from "react-select";
import _ from 'lodash'
const pageSize =5;
const Tecassignmain = () => {


  // Display OAT users

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers, setAllusers] = useState([])
  const [allAssignusers, setAssignAllusers] = useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);

  useEffect(()=>{

    getAssignUsers()
    getUsers()
  }, [])


  

    function getAssignUsers(){


      console.log("Token", token)
    fetch(`${BASE_URL}/Tec/GettecAssign`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data)
        setAssignAllusers(data)
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          }
      );
  
  console.log("check",allusers)
    }
    const pageCount = allAssignusers? Math.ceil(allAssignusers.length/pageSize) :0;
    // if (pageCount === 1)
    // return null;
    
    const pages = _.range(1, pageCount+1)
    
    const pagination =(pageNo)=>{
    
      // if (pageCount === 1)
    // return null;
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allAssignusers).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost)
    }
    
    const onNext = () => {


      pagination(currentPage + 1);
    };
    
    const onPrevious = () => {
      pagination(currentPage - 1);
    };
    



    function getUsers(){


      console.log("Token", token)
    fetch(`${BASE_URL}/Tec/Gettecusers`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data)
        setAllusers(data)
        getAssignUsers()
          }
      );
  
  console.log("check",allusers)
    }


    
  // AssignSection

  const [selectedOptions, setSelectedOptions] = useState();

 
  const optionList = [
    { value: "Index", label: "Index" },
    { value: "Company", label: "Company" },
    { value: "Expertise", label: "Expertise" },
    { value: "Technologies", label: "Technologies" },
    { value: "Products", label: "Products" },
    { value: "Talk to Us", label: "Talk to Us" }
  ];

  function handleSelect(data) {
    setSelectedOptions(data);
  }




  function AssignSection(){


    //  let checkbox = document.getElementById('checkbox').value
     var id = document.getElementById('tecuserid').value;
     
   
     let assign = selectedOptions.map((item) => item.label);
     console.log(assign)
     //const allFruits = Object.assign({}, ...assign);
     let section = assign.toString();
   
    
    
   
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

    // console.log(section);
    
    const body ={
      id:id,  
      section:section,
      assignStatus:0
    }
    console.log(body);
    axios({

      method:"POST",
      url:`${BASE_URL}/Tec/AssignSection`,
      data:body,
      headers: {
        "Content-Type" : "application/json",

        'Authorization':bearer 
      }

  })
  .then((response) =>{
    console.log(response.data);
    
    // toast.success("Task Assigned Successfully !", {
    //   position: "top-center",
    //   autoClose: 3200,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    //   className: 'toast-message'
    //   });
    setSuccessToast(true)
    setcurrentPage(1)
      setTimeout(() => {
       
        getUsers();
        setSuccessToast(false)
        document.getElementById("assignform").reset()
        setSelectedOptions("")
      }, 3000);
     
   })
   .catch(error => {
   console.log(error);
  alert("failed !")

    })
    }

      //SelectParticular

      const [Edittec, setEdittec] =useState([])

      function SelectParticular(Id){

        const body =
          {
            
           id:Id
          }
          console.log('body',body);
    
        
          axios({
                 method:"POST",
                 url :`${BASE_URL}/Tec/Getparticularid`,
                 data:body, 
                 headers: {
                      "Content-type": "application/json",
                      "Authorization": "Bearer " + `${token}`,
                  }     
              }) 
              
         
              .then((response) =>{
                console.log(response.data);
           
             
                setEdittec(response.data)
                      
                localStorage.setItem("EditData",JSON.stringify(response.data))
                
             })
             .catch(error => {
               console.log(error);
               
             })
       }



       function DeleteStatus(Id,UserName){
  
        //confirm delete

     
         const body ={
          id: Id
        }
         console.log(body)
          axios({
         
          method:"POST",
         url:`${BASE_URL}/Tec/AssignStatus`,
         data:body,
         headers: {
         "Content-Type" : "application/json",

         "Authorization": "Bearer " + `${token}`,
      
         }
        
          })
          .then((response) =>{
          console.log(response.data);

          closeForm();
       
          // toast.info(  "Deleted"+" " + UserName +  "!", {
          //  position: "top-center",
          //  autoClose: 3200,
          //  hideProgressBar: false,
          //  closeOnClick: true,
          //  pauseOnHover: true,
          //  draggable: true,
          //  progress: undefined,
          //  className: 'toast-message'
          //  });
          setcurrentPage(1)
          setDeleteErrToast(true)
           setTimeout(() => {
            setDeleteErrToast(false)
            setcurrentPage(1)
             getUsers()
           }, 3000);
         
         
          })
       
             
      
         }

     function closeForm(){
      document.getElementById("modaldeleteForm").style.display ="None"

     }

  //  ConfirmDelete 


  function ConfirmDelete(Id,UserName)
    {
      SelectParticular(Id,UserName)

      setTimeout(() => {
        document.getElementById("modaldeleteForm").style.display = "block";
      },1000);
     
     }  


     const[SuccessToast,setSuccessToast] = useState(false);
     const[DeleteToast,setDeleteErrToast] = useState(false);
  return (
    <>
    <div className='tec-addmain'>

    {/* <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />  */}



<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">ASSIGN </span></span>
 
 <div className='tec-addmain-back'>
  <Link to="/Kdp Tec"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 {/* <span id="Ehr"></span> */}
 </div>

    </div>  


     {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Sections Assigned Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 
 <form id="assignform">
 <div className='tec-AssignMain-table'>
<div className="tecAssignMain-table-responsive">
 <table class="AssignMain-Table-tec">

  <thead>
    <tr>
     
      <th>USERNAME</th>
      <th> ASSIGN</th>
      <th> ACTION</th>
      </tr>
  </thead>
  <tbody>

  <tr>
      
     
     <td style={{whiteSpace:"nowrap"}}><select className='tec-Assign-select' id='tecuserid'>
     {allusers.map((e) => {
      return <option className='tec-content' value={e.id}>{e.userName}</option>})}<br></br>
  
</select></td> 
<td id="ScrollAssignTec" style={{whiteSpace:"nowrap",width:"300px"}} >          
       <div><Select  
       
      className="dropdown"
  options={optionList}
  id="tecAselect"
  placeholder="Select Section"
  value={selectedOptions}
  onChange={handleSelect}
  isSearchable={true}
  isMulti
  isClearable
/></div>

 </td>
      <td className='text-center'>
       
<button className='tec-Assign-button' onClick={AssignSection}> ASSIGN </button>
</td>
      
    </tr>

   
 
  </tbody>
</table>

</div>
</div>
</form>  
{/* // section display table */}
{
   allAssignusers.length==0 ? <div id="TecApiFail">" No Data Found "</div>:(
    <div>  
<div className='tec-Assign-table'>

<div class="tecAssign-table-responsive">

 <table className='Assign-Table-tec'>
  <thead>
    <tr>
     
      <th>USERNAME</th>
      <th>SECTION</th>
      <th>ACTION</th>
      </tr>
  </thead>
  <tbody>

  {paginatedPosts.map((e) => {
      return<tr>
      
      <td>{e.userName}</td>
      <td >
      {e.section}
     </td>
     <td>
      <span class="tecAssign-action_btn">
      <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="OatDelicon"></i></span>
            
            </span>
      </td>
      
      
    </tr>

  
    })}
  </tbody>
</table>

</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
             {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>
)}
{/* DeletePopup */}

{Edittec.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
</div>

 </>
 
  )
}
export default Tecassignmain
